import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import axios from 'axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'WageBasicEmpDelete',
  props: {
  item: {
    type: Object,
    required: true,
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props;
const deleteEmpAtt = async () => {
  try {
    const isConfirmed = window.confirm('정말 삭제하시겠습니까?');
    if (isConfirmed) {
      const code = props.item.sisulCode;
      const empNum = props.item.empNum;
      const eaYm = props.item.eaYm;

      const response = await axios.post(`/api/deleteEmpAtt/${code}/${empNum}/${eaYm}`);
      const result = response.data;
      if (result.success === true) {
        alert('삭제가 완료되었습니다.');
        emit('success');
      } else {
        alert('삭제에 실패하였습니다. 관리자에게 문의해주세요.');
      }
    }else{
      return;
    }
  } catch (error) {
    alert('삭제작업을 처리할 수 없습니다.');
    console.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_component_v_icon, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteEmpAtt())),
    color: "blue-grey-darken-2",
    class: "SsDeleteIcon"
  }, {
    default: _withCtx(() => [
      _createTextVNode("mdi-delete")
    ]),
    _: 1
  }))
}
}

})